import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'appointment-request-sent-message',
  styleUrl: 'appointment-request-sent-message.css',
})
export class AppointmentRequestSentMessage {
  @Prop() appointmentDay: string = '';
  @Prop() appointmentMonth: number;
  @Prop() appointmentTime: string = '';
  @Prop() appointmentYear: string = '';

  @Prop() dealer: string = '';

  private monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  getDayName(date = new Date(), locale = 'en-US') {
    return date.toLocaleDateString(locale, { weekday: 'long' });
  }

  setDay() {
    if (this.appointmentDay) {
      return this.getDayName(new Date(parseInt(this.appointmentYear), this.appointmentMonth - 1, parseInt(this.appointmentDay)));
    }
  }

  render() {
    return (
      <div class="text-center md:px-4">
        <div class="text-green-500 mb-4">
          <div class="text-xl font-bold mb-2">Appointment Request Sent</div>
          {this.appointmentDay && (
            <div class="text-lg">
              {this.setDay()}, {this.monthNames[this.appointmentMonth - 1]} {this.appointmentDay} {this.appointmentYear} at {this.appointmentTime}
            </div>
          )}
        </div>
        <div>
          <div class="text-xl font-bold">{this.dealer}</div>
          <div>will reach out to you shortly to confirm your requested appointment.</div>
        </div>
      </div>
    );
  }
}
